<mat-card appearance="outlined">
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate" color="primary" />
  }
  <mat-card-header class="flex-row">
    <mat-card-title>Linked Campaigns</mat-card-title>
    <div class="text-right flex-1">
      <lib-button color="primary" (click)="onAdd()" icon="corporate_fare">Add Campaign</lib-button>
    </div>
  </mat-card-header>
  <mat-card-content>
    <table mat-table [dataSource]="linkedCampaigns ?? []" class="linked-campaigns-table">

      <!-- Name -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Program name</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <!-- Type -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let row">{{ row.type }}</td>
      </ng-container>

      <!-- Campaigns -->
      <ng-container matColumnDef="campaigns">
        <th mat-header-cell *matHeaderCellDef>Campaigns</th>
        <td mat-cell *matCellDef="let row">
          <div class="campaign-chips">
            @for (c of (row.campaigns ?? []); track c.campaignId) {
              @let badge = campaignBadgeFn(c);
              <span class="campaign-chip">
                <span class="campaign-chip__title">{{ c.title }}</span>
                @if (badge) {
                  <span [class]="'campaign-badge ' + badge.cssClass">{{ badge.text }}</span>
                }
              </span>
            }
          </div>
        </td>
      </ng-container>

      <!-- Locations diff -->
      <ng-container matColumnDef="locations">
        <th mat-header-cell *matHeaderCellDef>Locations</th>
        <td mat-cell *matCellDef="let row">
          @if (hasLocationDiff(row)) {
            <span class="location-badge location-badge--diff location-badge--clickable"
                  (click)="openLocationDetail(row)">
              <mat-icon class="location-badge__icon">warning</mat-icon>
              Different locations
            </span>
          } @else {
            <span class="location-badge location-badge--same"
                  [matTooltip]="getLocationTooltip(row)"
                  matTooltipShowDelay="200">
              <mat-icon class="location-badge__icon">check_circle</mat-icon>
              Same locations
            </span>
          }
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <lib-button variant="icon" icon="edit" color="primary"
            matTooltip="Edit" (buttonClick)="onEdit(row)"></lib-button>
          <lib-button variant="icon" icon="delete" color="primary"
            matTooltip="Remove" (buttonClick)="onRemove(row)"></lib-button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="padding: 16px; text-align: center;">
          No linked campaigns.
        </td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>
